/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useState } from 'react'
import { StyledDropdownContainer } from './style'
import { Dropdown } from 'react-bootstrap'
import { useEffect } from 'react'

export default function StyledDropdown({
  className = '',
  titleKey = 'name',
  options = [],
  defaultValueId,
  onChange = () => {},
  renderExtra = () => {},
}) {
  const [value, setValue] = useState(null)

  const onSelect = (option) => {
    setValue(options.find((_option) => _option.id === option.id))
    onChange(option)
  }

  useEffect(() => {
    setValue(options.find((_option) => _option.id === defaultValueId))
  }, [defaultValueId])

  return (
    <StyledDropdownContainer className={className}>
      <Dropdown.Toggle id="dropdown-basic">
        {value
          ? value[titleKey]
          : defaultValueId
          ? options.find((_option) => _option.id == defaultValueId)
            ? options.find((_option) => _option.id == defaultValueId)[titleKey]
            : 'Select'
          : 'Select'}
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {options.map((_option, _i) => (
          <Dropdown.Item key={_i} onClick={() => onSelect(_option)}>
            {_option.name}
          </Dropdown.Item>
        ))}
        {renderExtra() && <Dropdown.Item>{renderExtra()}</Dropdown.Item>}
      </Dropdown.Menu>
    </StyledDropdownContainer>
  )
}
